
export enum ConversationSetupType {
    FunctionDescription = 0,
    PersonnelFiles = 1,
    Qualifications = 2,
    Accountabilities = 3,
    Competences = 4,
    Skills = 5,
    DevelopmentObjectives = 6,
    Courses = 7,
    LibraryItem = 8,
    PerformanceObjectives = 9,
    OpenQuestions = 10,
    Chat = 11,
    Notepad = 12,
    Pdf = 13
}
